import React from "react";

import { faQuestionCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import { type ArticleID, isDesktopApp, isTeams, showHelpCenter } from "~/lib/utils";

import styles from "./css/HelpCenterLink.module.css";

interface LinkProps {
	children: string | React.ReactNode;
	articleId?: ArticleID;
	className?: string;
	onClick?: () => void;
}

export default function HelpCenterLink({ children, articleId, className, onClick }: LinkProps) {
	const onShowHelp = React.useCallback(
		(e: React.MouseEvent) => {
			if (window.Intercom) {
				if (!e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
					e.preventDefault();
					showHelpCenter(articleId);
				}
			}
			onClick?.();
		},
		[articleId, onClick],
	);

	const href = articleId ? `https://help.fellow.app/en/articles/${articleId}` : "https://help.fellow.app/";

	return (
		<a
			href={href}
			target={isDesktopApp || isTeams ? "_self" : "_blank"}
			rel="noopener"
			onClick={onShowHelp}
			className={className}
		>
			{children}
		</a>
	);
}

interface IconProps {
	title: string;
	articleId?: ArticleID;
	className?: string;
	onClick?: () => void;
}

export function HelpCenterIcon({ title, articleId, className, onClick }: IconProps) {
	const onShowHelp = React.useCallback(
		(e: React.MouseEvent) => {
			if (window.Intercom) {
				if (!e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
					e.preventDefault();
					showHelpCenter(articleId);
				}
			}
			onClick?.();
		},
		[articleId, onClick],
	);

	const href = articleId ? `https://help.fellow.app/en/articles/${articleId}` : "https://help.fellow.app/";

	return (
		<a
			href={href}
			target={isDesktopApp || isTeams ? "_self" : "_blank"}
			rel="noopener"
			title={title}
			onClick={onShowHelp}
			className={cx(className, styles.iconButton)}
		>
			<FontAwesomeIcon icon={faQuestionCircle} />
		</a>
	);
}
